const forfaits = [
	{
		id: 1,
		label: " Forfait Réparation Volet Roulant (Accès facile)",
		value: "Réparation Mécanique Volet Roulant facile",
		description:
			"* Forfait Réparation Volet Roulant :\n" +
			'- Contrôle complet du mécanisme.\n' +
			'- Remise en état du volet roulant et rétablissement du bon fonctionnement.\n' +
			"- Réglage des fins de course et des points d'arrêt\n" +
			"- Remplacement des petites pièces d'usure incluses (Manivelle, boîte à sangle,attaches tablier, verrous automatiques, clips de fixation).\n" +
			"- Vérification finale et essais de fonctionnement.\n",
		lst_price: 150,
		isInline: true,
	},
	{
		id: 110,
		label: " Forfait Réparation Volet Roulant (Accès standard)",
		value: "Réparation Mécanique Volet Roulant standard",
		description:
			"* Forfait Réparation Volet Roulant :\n" +
			'- Contrôle complet du mécanisme.\n' +
			'- Remise en état du volet roulant et rétablissement du bon fonctionnement.\n' +
			"- Réglage des fins de course et des points d'arrêt\n" +
			"- Remplacement des petites pièces d'usure incluses (Manivelle, boîte à sangle,attaches tablier, verrous automatiques, clips de fixation).\n" +
			"- Vérification finale et essais de fonctionnement.\n",
		lst_price: 200,
		isInline: true,
	},
	{
		id: 121,
		label: " Forfait Réparation Volet Roulant (Accès DIFFICILE)",
		value: "Réparation Mécanique Volet Roulant DIFFICILE",
		description:
			"* Forfait Réparation Volet Roulant :\n" +
			'- Contrôle complet du mécanisme.\n' +
			'- Remise en état du volet roulant et rétablissement du bon fonctionnement.\n' +
			"- Réglage des fins de course et des points d'arrêt\n" +
			"- Remplacement des petites pièces d'usure incluses (Manivelle, boîte à sangle,attaches tablier, verrous automatiques, clips de fixation).\n" +
			"- Vérification finale et essais de fonctionnement.\n",
		lst_price: 280,
		isInline: true,
	},
	{
		id: 131,
		label: " Forfait Réparation Volet Roulant (Accès ULTRA DIFFICILE)",
		value: "Réparation Mécanique Volet Roulant ULTRA DIFFICILE",
		description:
			"* Forfait Réparation Volet Roulant :\n" +
			'- Contrôle complet du mécanisme.\n' +
			'- Remise en état du volet roulant et rétablissement du bon fonctionnement.\n' +
			"- Réglage des fins de course et des points d'arrêt\n" +
			"- Remplacement des petites pièces d'usure incluses (Manivelle, boîte à sangle,attaches tablier, verrous automatiques, clips de fixation).\n" +
			"- Vérification finale et essais de fonctionnement.\n",
		lst_price: 380,
		isInline: true,
	},
	{
		id: 132,
		label: 'Forfait Réglage des fins de course (Accès facile)',
		value: 'Réglage des fins de course facile',
		description:
			'* Forfait Réglage des fins de course :\n' +
			'- Réinitialisation et remise à zéro de la mémoire de la télécommande\n' +
			'- Réglage des positions haute et basse du volet roulant\n' +
			'- Validation de la programmation et verrouillage de la mémoire\n' +
			'- Tests complets : montée, descente et arrêt\n',
		lst_price: 180,
		isInline: true,
	},
	{
		id: 133,
		label: 'Forfait Réglage des fins de course (Accès difficile)',
		value: 'Réglage des fins de course difficile',
		description:
			'* Forfait Réglage des fins de course :\n' +
			'- Réinitialisation et remise à zéro de la mémoire de la télécommande\n' +
			'- Réglage des positions haute et basse du volet roulant\n' +
			'- Validation de la programmation et verrouillage de la mémoire\n' +
			'- Tests complets : montée, descente et arrêt\n',
		lst_price: 280,
		isInline: true,
	},
	// {
	// 	id: 1,
	// 	label: "Forfait Déblocage d'un volet roulant (facile)",
	// 	value: "Déblocage d'un volet roulant facile",
	// 	description:
	// 		"* Forfait Déblocage d'un volet roulant :\n" +
	// 		'- Déblocage du volet manuellement\n' +
	// 		'- Réajustement et remise en fonctionnement du mécanisme / des lames\n' +
	// 		'- Contrôle complet du volet après intervention',
	// 	lst_price: 180,
	// 	isInline: true,
	// },
	// {
	// 	id: 1,
	// 	label: "Forfait Déblocage d'un volet roulant (difficile)",
	// 	value: "Déblocage d'un volet roulant difficile",
	// 	description:
	// 		"* Forfait Déblocage d'un volet roulant :\n" +
	// 		'- Déblocage du volet manuellement\n' +
	// 		'- Réajustement et remise en fonctionnement du mécanisme / des lames\n' +
	// 		'- Contrôle complet du volet après intervention.',
	// 	lst_price: 280,
	// 	isInline: true,
	// },

	{
		id: 20,
		label: 'Forfait Changement de manivelle pour volet roulant manuel',
		value: 'Changement de manivelle pour volet roulant manuel',
		description:
			'* Forfait Changement de manivelle pour volet roulant : \n' +
			'Fourniture :\n' +
			'- Manivelle pour volet roulant manuel, compatible avec l’installation existante\n' +
			'- Accessoires de fixation (visserie, cache, embouts)\n\n' +
			'Main d’œuvre :\n' +
			'- Dépose de l’ancienne manivelle défectueuse\n' +
			'- Vérification du bon état du treuil et de la sortie de caisson\n' +
			'- Installation de la nouvelle manivelle\n' +
			'- Réglage de la longueur et de l’axe de manœuvre\n' +
			'- Essais de fonctionnement montée / descente\n' +
			'- Vérification du bon enroulement du tablier\n',
		lst_price: 180,
		isInline: true,
	},
	{
		id: 21,
		label: 'Fourniture et pose de mécanisme complet (manivelle + tige)',
		value: 'Fourniture et pose mécanisme complet volet roulant manuel',
		description:
			'* Fourniture et pose de mécanisme complet (manivelle + tige) : \n' +
			'Fourniture :\n' +
			'- Mécanisme complet de manœuvre pour volet roulant manuel (manivelle + tige)\n' +
			'- Accessoires de fixation nécessaires (visserie, caches, embouts)\n\n' +
			'Main d’œuvre :\n' +
			'- Dépose de l’ancien mécanisme de manœuvre existant\n' +
			'- Fourniture et remplacement des petites pièces de fixation si nécessaire\n' +
			'- Mise en place et réglage du nouveau mécanisme de manœuvre (manivelle et tige)\n' +
			'- Fixation de la manivelle et alignement de la tige\n' +
			'- Essais de fonctionnement montée / descente du volet roulant\n' +
			'- Nettoyage et remise en état du chantier après intervention\n',
		lst_price: 350,
		isInline: true,
	},
	{
		id: 20,
		label: "Forfait Changement des agrafes d'un volet roulant (Facile)",
		value: "Changement des agrafes d'un volet roulant Facile",
		description:
			"* Forfait Changement des agrafes d'un volet roulant : \n" +
			'Fourniture :\n' +
			'- Agrafes / attaches de tablier pour volet roulant, compatibles avec l’installation existante\n' +
			'- Éléments de fixation nécessaires (axes, clips, visserie selon configuration)\n\n' +
			'Main d’œuvre :\n' +
			'- Ouverture du coffre du volet roulant\n' +
			'- Dépose des agrafes / attaches défectueuses\n' +
			'- Vérification de l’état du tablier et de l’axe d’enroulement\n' +
			'- Installation des nouvelles agrafes de tablier\n' +
			'- Réglage et fixation du tablier sur l’axe\n' +
			'- Essais de fonctionnement montée / descente\n' +
			'- Vérification du bon alignement et de l’enroulement du volet\n',
		lst_price: 170,
		isInline: true,
	},
	{
		id: 20,
		label: "Forfait Changement des agrafes d'un volet roulant (Difficile)",
		value: "Changement des agrafes d'un volet roulant Difficile",
		description:
			"* Forfait Changement des agrafes d'un volet roulant : \n" +
			'Fourniture :\n' +
			'- Agrafes / attaches de tablier pour volet roulant, compatibles avec l’installation existante\n' +
			'- Éléments de fixation nécessaires (axes, clips, visserie selon configuration)\n\n' +
			'Main d’œuvre :\n' +
			'- Ouverture du coffre du volet roulant\n' +
			'- Dépose des agrafes / attaches défectueuses\n' +
			'- Vérification de l’état du tablier et de l’axe d’enroulement\n' +
			'- Installation des nouvelles agrafes de tablier\n' +
			'- Réglage et fixation du tablier sur l’axe\n' +
			'- Essais de fonctionnement montée / descente\n' +
			'- Vérification du bon alignement et de l’enroulement du volet\n',
		lst_price: 280,
		isInline: true,
	},

	{
		id: 4,
		label: 'Forfait Remplacement de télécommande',
		value: 'Remplacement de télécommande',
		description:
			'* Forfait Remplacement de télécommande : \n' +
			'Fourniture :\n' +
			'- Remplacement de la télécommande adapté a la motorisation existante \n' +
			'- Paramétrage des canaux et fonctions selon l’installation\n\n' +
			'Main d’œuvre :\n' +
			'- Diagnostic du système de motorisation et de la compatibilité de la télécommande\n' +
			'- Mise en mode apprentissage du moteur ou du récepteur\n' +
			'- Programmation et synchronisation de la télécommande\n' +
			'- Test des fonctions montée / descente / arrêt\n' +
			'- Vérification du bon fonctionnement et de la portée de la télécommande\n',

		lst_price: 220,
		isInline: true,
	},

	{
		id: 20,
		label: 'Forfait Déblocage du rideau métallique',
		value: 'Forfait Déblocage du rideau métallique',
		description:
			'*Forfait Déblocage du rideau métallique :\n' +
			'- Diagnostic et identification de la cause du blocage\n' +
			'- Manipulation et déblocage manuel du rideau métallique\n' +
			'- Vérification du bon fonctionnement après intervention\n' +
			'- Nettoyage et remise en ordre de la zone de travail\n',
		lst_price: 330,
		isInline: true,
	},

	{
		id: 4,
		label: "Forfait Remplacement d'une serrure a l'identique d'un rideau métallique",
		value: "Remplacement d'une serrure a l'identique d'un rideau métallique",
		description:
			"*Forfait Remplacement d'une serrure a l'identique d'un rideau métallique\n" +
			'- Sécurisation du rideau métallique :\n' +
			'- Dépose de l’ancienne serrure\n' +
			'- Pose de la serrure neuve à l’identique\n' +
			'- Réglages et tests de bon fonctionnement\n',
		lst_price: 180,
		isInline: true,
	},

	{
		id: 9,
		label: 'Forfait remplacement des agrafes de rideau métallique',
		value: 'Forfait remplacement des agrafes de rideau métallique',
		description:
			'*Forfait remplacement des agrafes de rideau métallique :\n' +
			'- Dépose des agrafes défectueuses du rideau métallique\n' +
			'- Fourniture et pose de nouvelles agrafes compatibles\n' +
			'- Réglage et fixation du rideau sur l’axe\n' +
			'- Vérification du bon fonctionnement après intervention\n',
		lst_price: 180,
		isInline: true,
	},
	{
		id: 17,
		label: "Forfait fourniture et pose d'un sabot de rideau métallique",
		value: "Forfait fourniture et pose d'un sabot de rideau métallique",
		description:
			"*Forfait fourniture et pose d'un sabot de rideau métallique :\n" +
			'- Fourniture d’un sabot compatible avec le rideau métallique existant\n' +
			'- Dépose de l’ancien sabot si nécessaire\n' +
			'- Pose et fixation du nouveau sabot\n' +
			'- Réglage et test du bon fonctionnement du rideau métallique\n',
		lst_price: 220,
		isInline: true,
	},
	{
		id: 11,
		label: 'Forfait déblocage de store banne',
		value: 'Forfait déblocage de store banne',
		description:
			'*Forfait déblocage de store banne :\n' +
			'- Diagnostic de l’origine du blocage du store banne\n' +
			'- Déblocage manuel du mécanisme\n' +
			'- Vérification du bon fonctionnement ouverture / fermeture\n' +
			'- Remise en état et sécurisation du store après intervention\n',
		lst_price: 220,
		isInline: true,
	},

	{
		id: 13,
		label: 'Forfait dépose et repose de store banne',
		value: 'Forfait dépose et repose de store banne',
		description:
			'*Forfait dépose et repose de store banne :\n' +
			'- Dépose complète du store banne existant\n' +
			'- Intervention sur le support ou l’environnement si nécessaire\n' +
			'- Repose du store banne dans les règles de l’art\n' +
			'- Réglages et tests de bon fonctionnement\n',
		lst_price: 300,
		isInline: true,
	},

	{
		id: 14,
		label: 'Forfait dépose de store banne',
		value: 'Forfait dépose de store banne',
		description:
			'*Forfait dépose de store banne :\n' +
			'- Dépose sécurisée du store banne existant\n' +
			'- Désolidarisation des fixations murales ou supports\n' +
			'- Mise en sécurité du store après dépose\n',
		lst_price: 150,
		isInline: true,
	},

	{
		id: 15,
		label: 'Forfait pose de store banne',
		value: 'Forfait pose de store banne',
		description:
			'*Forfait pose de store banne :\n' +
			'- Pose du store banne sur supports existants ou préparés\n' +
			'- Fixation et mise à niveau du store\n' +
			'- Réglage des bras et de l’inclinaison\n' +
			'- Tests de bon fonctionnement ouverture / fermeture\n',
		lst_price: 150,
		isInline: true,
	},

	{
		id: 16,
		label: 'Forfait remplacement d’une ficelle de store',
		value: 'Forfait remplacement d’une ficelle de store',
		description:
			'*Forfait remplacement d’une ficelle de store :\n' +
			'- Dépose de la ficelle usée ou rompue\n' +
			'- Fourniture et pose d’une ficelle neuve compatible\n' +
			'- Réglage de la tension et du mécanisme\n' +
			'- Essais de fonctionnement du store\n',
		lst_price: 260,
		isInline: true,
	},
];

export default forfaits;
